"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { X, Plus } from "lucide-react";
import { cn } from "@/utilities/ui";
export function SideMenu(t0) {
  const $ = _c(35);
  const {
    items,
    sociallinks,
    onClose,
    isOpen: t1
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [expandedItems, setExpandedItems] = React.useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = id => {
      setExpandedItems(prev => prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const toggleItem = t3;
  let t4;
  let t5;
  if ($[2] !== isOpen) {
    t4 = () => {
      if (isOpen) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
      return _temp;
    };
    t5 = [isOpen];
    $[2] = isOpen;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  React.useEffect(t4, t5);
  let t6;
  if ($[5] !== isOpen || $[6] !== onClose) {
    t6 = isOpen && <div className="fixed inset-0 bg-black/80 z-40 transition-opacity duration-300 ease-in-out overflow-y-scroll" onClick={onClose} />;
    $[5] = isOpen;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isOpen ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0";
  let t8;
  if ($[8] !== t7) {
    t8 = cn(" fixed inset-y-0 left-0 z-50 w-[300px] bg-card text-primary transform transition-all duration-300 ease-in-out overflow-y-auto", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <X className="h-6 w-6" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onClose) {
    t10 = <div className="flex justify-end p-4"><button onClick={onClose} className="text-primary hover:text-gray-300 transition-colors" aria-label="Close menu">{t9}</button></div>;
    $[11] = onClose;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== expandedItems || $[14] !== items) {
    let t12;
    if ($[16] !== expandedItems) {
      t12 = item_0 => <div key={item_0.id} className="border-b border-gray-800"><div className="py-4 flex justify-between items-center"><a href={item_0.href || "#"} className="text-sm tracking-wider uppercase hover:text-gray-300 transition-colors">{item_0.title}</a>{item_0.expandable && <button onClick={() => toggleItem(item_0.id)} className="text-white hover:text-gray-300 transition-colors" aria-label={`Expand ${item_0.title}`}><Plus className={cn("h-4 w-4 transition-transform duration-300", expandedItems.includes(item_0.id) ? "rotate-45" : "")} /></button>}</div>{item_0.expandable && <div className={cn("overflow-hidden transition-all duration-300 ease-in-out", expandedItems.includes(item_0.id) ? "max-h-48 opacity-100" : "max-h-0 opacity-0")}><div className="pb-4 transform transition-transform duration-300 ease-in-out">{item_0.items?.map(_temp2)}</div></div>}</div>;
      $[16] = expandedItems;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    t11 = items.map(t12);
    $[13] = expandedItems;
    $[14] = items;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <nav className="px-6 flex-grow overflow-y-auto">{t11}</nav>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mb-4">Keep in touch</div>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== sociallinks) {
    t14 = sociallinks?.map(_temp3);
    $[21] = sociallinks;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <div className="p-6">{t13}<div className="flex items-center justify-center justify-items-center gap-x-3 lg:justify-self-end">{t14}</div></div>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t12 || $[26] !== t15) {
    t16 = <div className="flex flex-col justify-between min-h-[90vh]">{t12}{t15}</div>;
    $[25] = t12;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t10 || $[29] !== t16 || $[30] !== t8) {
    t17 = <div className={t8}>{t10}{t16}</div>;
    $[28] = t10;
    $[29] = t16;
    $[30] = t8;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17 || $[33] !== t6) {
    t18 = <>{t6}{t17}</>;
    $[32] = t17;
    $[33] = t6;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
}
function _temp3(link, index) {
  return <a key={index} href={link.url}><i className={`fi ${link.icon}`} /></a>;
}
function _temp2(subItem) {
  return <a key={subItem.id} href={subItem.href || "#"} className="block py-2 pl-4 text-sm text-gray-400 hover:text-white transition-colors">{subItem.title}</a>;
}
function _temp() {
  document.body.classList.remove("overflow-hidden");
}